import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/App';
import '@/styles/globals.css';

const container = document.getElementById('root');

// A missing root element means index.html and this entry point have drifted
// apart. Failing loudly here is far easier to debug than a silently blank page.
if (!container) {
  throw new Error('Root element #root was not found in the document.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
